import { render, staticRenderFns } from "./InformationMarkComponent.vue?vue&type=template&id=70638bd2&scoped=true&lang=pug"
import script from "./InformationMarkComponent.vue?vue&type=script&lang=js"
export * from "./InformationMarkComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationMarkComponent.vue?vue&type=style&index=0&id=70638bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70638bd2",
  null
  
)

export default component.exports